/** Pixel Meta de la version FR (Arts Martiaux Enfants — Cours Prêts™) : un pixel propre, jamais celui de la version anglaise.
 *  PageView au chargement, ViewContent quand l’offre est vue, InitiateCheckout UNIQUEMENT sur le bouton de l’offre. */
export const META_PIXEL_ID = '1660443269144667';
